import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6790146"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sqg-chart" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "around",
  "stroke-dasharray": "100, 100",
  d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
}, null, -1))
const _hoisted_3 = ["stroke-dasharray"]
const _hoisted_4 = {
  x: "18",
  y: "14",
  "text-anchor": "middle",
  dy: "7",
  "font-size": "20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      viewBox: "0 0 36 36",
      class: "circle-svg",
      style: _normalizeStyle(`width: ${_ctx.size}`)
    }, [
      _hoisted_2,
      _createElementVNode("path", {
        class: "percent",
        "stroke-dasharray": [`${_ctx.percent}, 100`],
        d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
      }, null, 8, _hoisted_3),
      _createElementVNode("text", _hoisted_4, _toDisplayString(_ctx.text), 1)
    ], 4))
  ]))
}